import React, { useEffect, useState } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import { Link, useHistory } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress, Paper } from "@material-ui/core";
import "./schoolAdminTeams.css";
import { formatPhoneNumber } from "../../../utils";
import moment from "moment";
import userService from "../../../services/user.service";
import SchoolStatus from "../SchoolAdminPages/SchoolStatus/SchoolStatus";
import ConfirmPopup from "../Popups/ConfirmPopup";
import SuccessDialog from "../Popups/SuccessDialog";
import DeleteDialog from "../Popups/DeleteDialog";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { userRoles } from "../../../utils/constant";
import LongMenu from "../../../Common/actionMenu";
import CustomSearch from "../../../Common/CustomSearch";
import ButtonWithToolTip from "../../../Common/ButtonWithToolTip";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";

const TeamAdmin = () => {
  const [teamAdminData, setTeamAdminData] = useState([]);
  const [resetPopup, setResetPopup] = useState(false);
  const [successPopUp, setSuccessPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [msg, setMsg] = useState("");
  const schoolId = getFromLocalStorage("schoolId");
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 10,
  });
  const [currentTeamAdmin, setCurrentTeamAdmin] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const currentSeason = useSelector(
    (state) => state.loggedInUser.userProfile.currentSeason
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );
  const userRole = useSelector((state) => state.loggedInUser.roles[0].role);
  useEffect(() => {
    getTeamAdmin();
  }, []);
  const getTeamAdmin = () => {
    setLoading(true);
    getTeamAdminsByPage(pageState.page, pageState.pageSize);
  };

  const getTeamAdminsByPage = (page, size) => {
    setPageState((old) => ({ ...old, isLoading: true }));
    userService.getAllTeamAdminsByPage(schoolId, page, size).then((res) => {
      setPageState((old) => ({
        ...old,
        isLoading: false,
        data: res.data.data.teamAdminResponses,
        total: res.data.data.total,
      }));
      setLoading(false);
      if (recordNotFound) {
        setRecordNotFound(false);
      }
    });
  };
  const history = useHistory();

  const formatDate = (date) => {
    return moment(date).format("MM-DD-YYYY");
  };

  const openResetPasswordDialog = (email) => {
    setEmail(email);
    setResetPopup(true);
  };

  const closeDialog = () => {
    setResetPopup(false);
  };

  const toggleSuccessDialog = () => {
    setSuccessPopup(!successPopUp);
  };

  const closeDeleteDialog = () => {
    setDeletePopup(false);
  };

  const sendResetLink = () => {
    userService.forgotPassword(email).then((res) => {
      if ((res.status == 200) & (res.data.success == true)) {
        setMsg("Reset Password link sent successfully!");
        setResetPopup(false);
        setSuccessPopup(true);
      }
    });
  };

  const deleteTeamAdmin = (id) => {
    deleteTeamAdminById(id).then(() => {
      setDeleteFlag(true);
      setMsg("Team Admin Removed Successfully");
      setSuccessPopup(true);
      setDeletePopup(false);
      if (searchedRecord) {
        searchTeamAdmin(searchQuery, pageState.page, 10);
      } else {
        getTeamAdminsByPage(pageState.page, 10);
      }
    });
  };

  const openDeleteDialog = (id) => {
    setMsg("Are You Sure You Want to Remove this team admin ?");
    setCurrentTeamAdmin(id);
    setDeletePopup(true);
  };

  const deleteTeamAdminById = () => {
    const ids = [currentTeamAdmin];
    return userService.deleteTeamAdmin(ids);
  };

  const tableColumns = [
    {
      field: "firstName",
      headerName: "Name",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      cellClassName: "custom-cell",
      renderCell: (params) => (
        <div className="d-flex-align-cent height-70 w-100">
          <p className="link-blue text-width-auto mg-auto">
            {params.row.firstName + " " + params.row.lastName}
          </p>
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      headerClassName: "table-header bold",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "signUpDate",
      headerName: "Sign-Up Date",
      flex: 1,
      minWidth: 150,
      headerClassName: "table-header bold",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => <p>{formatDate(params.row.createdAt)}</p>,
    },
    {
      field: "phoneNumber",
      headerName: "Phone Number",
      flex: 1,
      minWidth: 180,
      headerClassName: "table-header bold",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <p>{formatPhoneNumber(params.row.phoneNumber)}</p>
      ),
    },
    {
      field: "specialty",
      headerName: "Speciality",
      flex: 1,
      minWidth: 150,
      headerClassName: "table-header bold",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      headerClassName: "table-header bold",
      cellClassName: "mng-z-index",
      align: "center",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (
        <SchoolStatus
          status={params.row.user.active}
          isDeleted={params.row.user.deleted}
        />
      ),
    },
    {
      headerClassName: "table-header bold",
      cellClassName: "mng-z-index2",
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => (
        <div
          className="dropdown d-flex-center"
          onClick={(event) => event.stopPropagation()}
        >
          {userRole === userRoles.ROLE_SCHOOL_ADMIN && (
            <LongMenu
              rowData={params.row}
              openDialogResetPassword={openResetPasswordDialog}
              openDialog={openDeleteDialog}
              navigationLink="editteamadmin"
            />
          )}
        </div>
      ),
    },
  ];

  const searchTeamAdmin = (query, page, size) => {
    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setSearchQuery(query);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService
      .searchTeamAdmin(query, schoolId, page, size)
      .then((res) => {
        const { teamAdminResponses, total } = res.data.data;
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: teamAdminResponses,
          total: total,
          page: page,
        }));
        teamAdminResponses.length == 0
          ? setRecordNotFound(true)
          : setRecordNotFound(false);
      })
      .catch((err) => {
        setRecordNotFound(true);
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: [],
          total: 0,
          page: page,
        }));
      });
  };

  return (
    <div>
      <div>
        {userRole == userRoles.ROLE_SCHOOL_ADMIN ||
        userRole == userRoles.ROLE_TEAM_ADMIN ? (
          <div
            className={
              isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
            }
          >
            <SchoolAdminDashboard />
            <div className="mng-header stickyy">
              <h4 className="fs-24 bold mob-hd">
                Team Admins ({pageState.total})
              </h4>

              {userRole == userRoles.ROLE_SCHOOL_ADMIN && currentSeason ? (
                <Link to="/addteamadmin">
                  <button className="addBtnn2 mng-padding">
                    <AddIcon className="mx-1 addIconSc " />
                    {""}Add Team Admin
                  </button>
                </Link>
              ) : (
                <ButtonWithToolTip
                  buttonText="Add Team Admin"
                  toolTipText={
                    currentSeason
                      ? "You Don't Have Permission To Add Team Admin."
                      : "Please Create New Season Before Adding Team Admin."
                  }
                />
              )}
            </div>
            {loading && (
              <div className="content-layout-loading-animation">
                <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                  <CircularProgress
                    className="rounded-circle"
                    color="success"
                    sx={{ fontSize: 10, color: "#002244" }}
                    disableShrink
                  />
                </div>
              </div>
            )}
            {!loading && (
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
                {!loading && (pageState.data.length > 0 || recordNotFound) && (
                  <Paper className="pad-top-20">
                    <CustomSearch
                      searchQuery={searchQuery}
                      searchedRecord={searchedRecord}
                      setSearchedRecord={setSearchedRecord}
                      setSearchQuery={setSearchQuery}
                      getDataByPage={getTeamAdminsByPage}
                      searchData={searchTeamAdmin}
                      pageState={pageState}
                      setRecordNotFound={setRecordNotFound}
                    />
                    <DataGrid
                      rows={pageState.data}
                      rowCount={pageState.total}
                      loading={pageState.isLoading}
                      pagination
                      page={pageState.page}
                      columns={tableColumns}
                      pageSize={pageState.pageSize}
                      rowsPerPageOptions={[10]}
                      paginationMode="server"
                      onPageChange={(newPage) => {
                        if (searchQuery == "") {
                          getTeamAdminsByPage(newPage, 10);
                        } else {
                          searchTeamAdmin(searchQuery, newPage, 10);
                        }
                        setPageState((old) => ({
                          ...old,
                          page: newPage,
                        }));
                      }}
                      onPageSizeChange={(newPageSize) =>
                        setPageState((old) => ({
                          ...old,
                          pageSize: newPageSize,
                        }))
                      }
                      sx={{
                        color: "black",
                        fontFamily: "Rajdhani-SemiBold",
                        fontSize: "18px",
                        backgroundColor: "white",
                        borderBottomLeftRadius: "12px",
                        borderBottomRightRadius: "12px",
                      }}
                      onCellClick={(param) => {
                        history.push(`/teamadmindetails/${param.row.id}`);
                      }}
                      autoHeight
                      disableColumnMenu
                      getRowHeight={() => "auto"}
                    />
                  </Paper>
                )}
                <div className="clear20"></div>
                {!loading && !pageState.data.length > 0 && !recordNotFound && (
                  <div className="content-layout-loading-animation">
                    <p className="fs-20 bold">No Team Admin Found</p>
                  </div>
                )}
              </div>
            )}

            <ConfirmPopup
              open={resetPopup}
              closeDialog={closeDialog}
              sendResetLink={sendResetLink}
              email={email}
            />

            <SuccessDialog
              successPopUp={successPopUp}
              toggleSuccessDialog={toggleSuccessDialog}
              msg={msg}
            />

            <DeleteDialog
              open={deletePopup}
              closeDialog={closeDeleteDialog}
              deleteRecord={deleteTeamAdmin}
              deleteId={adminId}
              msg={msg}
            />
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </div>
    </div>
  );
};

export default TeamAdmin;
